import React, { FC } from 'react';

import { LinkButton } from '@adsk/alloy-react-button';
import EmptyState from '@adsk/alloy-react-empty-state';

import { useTranslation } from '../i18n';

interface EntityPickerModalErrorProps {
  onTryAgain?: () => void;
}

const EntityPickerModalError: FC<EntityPickerModalErrorProps> = ({
  onTryAgain,
}) => {
  const { t } = useTranslation();
  return (
    <EmptyState
      illustrationType={EmptyState.ILLUSTRATION_TYPES.CRANE_CONSTRUCTION_GREY}
      description={t('ERROR_LOADING')}
    >
      <LinkButton onClick={onTryAgain}>{t('TRY_AGAIN')}</LinkButton>
    </EmptyState>
  );
};

export default EntityPickerModalError;
